import React, { useState } from "react";
import Layout from "../components/layout";
import { Download } from "lucide-react";

const dummyPaySlips = [
  {
    id: 1,
    month: "April",
    year: "2025",
    grossPay: "₹75,000",
    netPay: "₹65,000",
    deductions: "₹10,000",
    downloadUrl: "/payslips/april-2025.pdf",
  },
  {
    id: 2,
    month: "March",
    year: "2025",
    grossPay: "₹72,000",
    netPay: "₹63,000",
    deductions: "₹9,000",
    downloadUrl: "/payslips/march-2025.pdf",
  },
];

export default function MyPaySlips() {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const filtered = dummyPaySlips.filter(
    (slip) =>
      (!selectedMonth || slip.month === selectedMonth) &&
      (!selectedYear || slip.year === selectedYear)
  );

  return (
    <Layout>
      <div className="p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">My Pay Slips</h1>

        <div className="flex gap-4 mb-6 flex-wrap">
          <select
            onChange={(e) => setSelectedMonth(e.target.value)}
            className="border rounded-lg px-4 py-2 text-sm"
            value={selectedMonth}
          >
            <option value="">All Months</option>
            <option value="January">January</option>
            <option value="February">February</option>
            <option value="March">March</option>
            <option value="April">April</option>
            <option value="May">May</option>
            {/* Add rest months */}
          </select>

          <select
            onChange={(e) => setSelectedYear(e.target.value)}
            className="border rounded-lg px-4 py-2 text-sm"
            value={selectedYear}
          >
            <option value="">All Years</option>
            <option value="2025">2025</option>
            <option value="2024">2024</option>
          </select>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {filtered.map((slip) => (
            <div
              key={slip.id}
              className="bg-white rounded-xl p-4 shadow hover:shadow-lg transition"
            >
              <div className="flex justify-between items-center mb-2">
                <div>
                  <h2 className="text-lg font-semibold">
                    {slip.month} {slip.year}
                  </h2>
                  <p className="text-sm text-gray-500">Gross Pay: {slip.grossPay}</p>
                  <p className="text-sm text-gray-500">Net Pay: {slip.netPay}</p>
                  <p className="text-sm text-gray-500">
                    Deductions: {slip.deductions}
                  </p>
                </div>
                <a
                  href={slip.downloadUrl}
                  download
                  className="text-blue-600 hover:text-blue-800"
                >
                  <Download className="w-5 h-5" />
                </a>
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <p className="text-gray-500">No payslips found for selected filters.</p>
          )}
        </div>
      </div>
    </Layout>
  );
}